type FieldTypes = "array" | "object";

interface FieldTypeConfig {
  [key: string]: FieldTypes;
}

export function transformToObj<T, C>(cache: C, fieldTypes: FieldTypeConfig): T {
  const result: any = { ...cache };

  for (const [field, type] of Object.entries(fieldTypes)) {
    try {
      if (typeof result[field] === "string") {
        result[field] = JSON.parse(result[field]);
      }

      if (type === "array" && !Array.isArray(result[field])) {
        result[field] = [];
      } else if (type === "object" && Array.isArray(result[field])) {
        result[field] = {};
      }

      if (!result[field]) {
        result[field] = type === "array" ? [] : {};
      }
    } catch {
      result[field] = type === "array" ? [] : {};
    }
  }

  return result as T;
}

export function transformToCache<T, C>(
  data: T,
  fieldTypes: FieldTypeConfig
): C {
  const cache: any = { ...data };

  for (const [field, type] of Object.entries(fieldTypes)) {
    if (field in cache) {
      const value = cache[field];
      cache[field] = JSON.stringify(
        type === "array" && !Array.isArray(value)
          ? []
          : type === "object" && Array.isArray(value)
          ? {}
          : value || (type === "array" ? [] : {})
      );
    }
  }

  return cache as C;
}
